import { render, staticRenderFns } from "./ScheduleNotes.vue?vue&type=template&id=61396b3c&"
import script from "./ScheduleNotes.vue?vue&type=script&lang=js&"
export * from "./ScheduleNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports